// 1.

// import React, { useEffect, useState, useContext } from 'react';
// import {
//     MapContainer,
//     TileLayer,
//     Marker,
//     Popup,
//     Tooltip
// } from 'react-leaflet';
// import L from 'leaflet';
// import 'leaflet/dist/leaflet.css';
// import { BusinessApi } from '../../../../../api/Api';
// import "./BusinessLocation.css"
// import { AppThemeContext } from '../../../../../context/AppThemeContext';
// import { padding } from '@mui/system';
// import { AuthenticationContext } from '../../../../../context/AuthenticationContext';
// import { APP_KEY } from "../../../../../api/AxiosApi";
// import { Link, useNavigate } from 'react-router-dom';
// import TopHeaderBusiness from "../../../../../components/general/TopHeaderBusiness";

// const center = [27.0, 80.0];

// const redIcon = new L.Icon({
//     className:"blink",
//     iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png',
//     shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
//     iconSize: [25, 41],
//     iconAnchor: [12, 41],
//     popupAnchor: [1, -34],
//     shadowSize: [41, 41]
// });

// const greenIcon = new L.Icon({
//     className:"blink",
//     iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-green.png',
//     shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
//     iconSize: [25, 41],
//     iconAnchor: [12, 41],
//     popupAnchor: [1, -34],
//     shadowSize: [41, 41]
// });

// export default function BusinessLocation() {
//     const { PrimaryColor } = useContext(AppThemeContext);
//     const [logData, setLogData] = useState([]);
//     const { userLogin } = useContext(AuthenticationContext);

//     const credentials = {
//         LOGIN_ID: localStorage.getItem("business_LOGIN_ID") || "",
//         SS_KEY: localStorage.getItem("business_SS_KEY")
//     };

//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 const res = await BusinessApi(credentials);
//                 if (res?.data && Array.isArray(res.data)) {
//                     setLogData(res.data);
//                 }
//             } catch (err) {
//                 console.error("Error fetching data:", err);
//             }
//         };

//         fetchData();
//     }, [credentials.LOGIN_ID]);

//     const handleLoginClick = (LOGIN_NAME, PW, USER_TYPE) => {
//         localStorage.setItem("pass", "target");
//         userLogin(LOGIN_NAME, PW, APP_KEY);
//     };

//     return (

//         <>
//          <TopHeaderBusiness/>
//          <MapContainer center={center} zoom={5} style={{ height: '80%', width: '99%',marginTop:".8rem" }}>
//             <TileLayer
//                 url="https://api.maptiler.com/maps/basic-v2/256/{z}/{x}/{y}.png?key=wqBRkwqr9CEgeNgas9mP"
//                 attribution='&copy; <a href="https://www.maptiler.com/copyright/">MapTiler</a> & <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
//             />


//             {logData
//                 .filter((data) => data.LATITUDE && data.LONGITUDE)
//                 .map((location, index) => {
//                     const markerIcon = location.STATUS?.toLowerCase() === 'online' ? greenIcon : redIcon;
//                     return (
//                         <Marker
//                             key={index}
//                             position={[parseFloat(location.LATITUDE), parseFloat(location.LONGITUDE)]}
//                             icon={markerIcon}
//                         >
//                             <Tooltip direction="top" offset={[0, -20]} opacity={1}>
//                                 <div className="tooltip-class">
//                                     <strong><h6>
//                                         <Link
//                                             // href="#"
//                                             to=""
//                                             // target="_blank"
//                                             onClick={(e) => {
//                                                 e.preventDefault()
//                                                 handleLoginClick(location.USER_ID, location.PASSWORD, location.USER_TYPE); // Call the function to login
//                                                 window.open("/userDashboard", "_blank", "noopener,noreferrer");
//                                             }}
//                                             style={{ textDecoration: "none", color: "#007BFF" }}

//                                         >
//                                             {location.user}
//                                         </Link>
//                                     </h6></strong>
//                                     <strong style={{ fontSize: "15px", color: "#007BFF" }}>Plant Capacity:</strong><span style={{ fontSize: "15px", color: "#007BFF" }}>{location.Plant_capacity}</span> <br />
//                                     <strong>Plant Location:</strong> {location.PLANT_LOCATION}<br />
//                                     <strong>Total KWH:</strong> {location.TOTAL_KWH}
//                                     <strong>Current KW:</strong> {location.LKW}<br />
//                                     <strong>Status:</strong>
//                                     <span
//                                         className='blink'
//                                         style={{
//                                             color:
//                                                 location.STATUS?.toLowerCase() === 'online'
//                                                     ? 'green'
//                                                     : location.STATUS?.toLowerCase() === 'offline'
//                                                         ? 'red'
//                                                         : 'orange' // optional fallback
//                                         }}
//                                     >
//                                         {location.STATUS}
//                                     </span>
//                                     <br />

//                                     <strong>Alarm:</strong><span className='blink' style={{ color: "orange" }}>{location.ALARM}</span><br />


//                                 </div>
//                             </Tooltip>
//                             <Popup>
//                                 <strong><h6>
//                                     <Link
//                                         // href="#"
//                                         to=""
//                                         // target="_blank"
//                                         onClick={(e) => {
//                                             e.preventDefault()
//                                             handleLoginClick(location.USER_ID, location.PASSWORD, location.USER_TYPE); // Call the function to login
//                                             window.open("/userDashboard", "_blank", "noopener,noreferrer");
//                                         }}
//                                         style={{ textDecoration: "none", color: "#007BFF" }}

//                                     >
//                                         {location.user}
//                                     </Link>
//                                 </h6></strong>
//                                 <strong style={{ fontSize: "15px", color: "#007BFF" }}>Plant Capacity:</strong><span style={{ fontSize: "15px", color: "#007BFF" }}>{location.Plant_capacity}</span> <br />
//                                 <strong>Plant Location:</strong> {location.PLANT_LOCATION}<br />
//                                 <strong>Total KWH:</strong> {location.TOTAL_KWH}<br/>
//                                 <strong>Current KW:</strong> {location.LKW}<br/>
//                                 <strong>Status:</strong>
//                                 <span
//                                     className='blink'
//                                     style={{
//                                         color:
//                                             location.STATUS?.toLowerCase() === 'online'
//                                                 ? 'green'
//                                                 : location.STATUS?.toLowerCase() === 'offline'
//                                                     ? 'red'
//                                                     : 'orange' // optional fallback
//                                     }}
//                                 >
//                                     {location.STATUS}
//                                 </span>
//                                 <br />

//                                 <strong>Alarm:</strong><span className='blink' style={{ color: "orange" }}>{location.ALARM}</span><br />
//                             </Popup>
//                         </Marker>
//                     );
//                 })}
//         </MapContainer>
//         </>

//     );
// }

// 2.

import React, { useEffect, useState, useContext } from 'react';
import {
    MapContainer,
    TileLayer,
    Marker,
    Popup,
    Tooltip
} from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { BusinessApi } from '../../../../../api/Api';
import "./BusinessLocation.css"
import { AppThemeContext } from '../../../../../context/AppThemeContext';
import { padding } from '@mui/system';
import { AuthenticationContext } from '../../../../../context/AuthenticationContext';
import AxiosApi, { APP_KEY } from "../../../../../api/AxiosApi";
import { Link, useNavigate } from 'react-router-dom';
import TopHeaderBusiness from "../../../../../components/general/TopHeaderBusiness";

const center = [27.0, 80.0];

const redIcon = new L.Icon({
    className: "blink",
    iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
});

const greenIcon = new L.Icon({
    className: "blink",
    iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-green.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
});

export default function BusinessLocation() {
    const { PrimaryColor } = useContext(AppThemeContext);
    const [logData, setLogData] = useState([]);
    const { userLogin } = useContext(AuthenticationContext);

    const credentials = {
        LOGIN_ID: localStorage.getItem("business_LOGIN_ID") || "",
        SS_KEY: localStorage.getItem("business_SS_KEY")
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await BusinessApi(credentials);
                if (res?.data && Array.isArray(res.data)) {
                    setLogData(res.data);
                }
            } catch (err) {
                console.error("Error fetching data:", err);
            }
        };

        fetchData();
    }, [credentials.LOGIN_ID]);

    // const handleLoginClick = (LOGIN_NAME, PW, USER_TYPE) => {
    //     localStorage.setItem("pass", "target");
    //     userLogin(LOGIN_NAME, PW, APP_KEY);
    // };

    const handleLoginClick = async (LOGIN_NAME, PW, USER_TYPE) => {
        try {
            let headersList = {
                Accept: "/",
                "Content-Type": "application/x-www-form-urlencoded",
            };

            let bodyParams = new URLSearchParams();
            bodyParams.append("LOGIN_NAME", LOGIN_NAME);
            bodyParams.append("PW", PW);
            bodyParams.append("APP_KEY", APP_KEY);

            const res = await AxiosApi.post("login/LoginWEB", bodyParams, headersList);
            const userData = res?.data;

            if (userData) {
                const encodedData = btoa(encodeURIComponent(JSON.stringify({
                    userInfo: userData,
                    loginId: LOGIN_NAME,
                    pw: PW,
                    lcode: userData?.Loc_Code,
                    isImpersonated: true
                })));

                // 🟢 लाइव फिक्स 1: 'noopener,noreferrer' के साथ 'window.open' का सही उपयोग
                // इससे नया टैब पुराने टैब के localStorage के साथ छेड़छाड़ नहीं कर पाएगा।
                const newWindow = window.open(`/#/userDashboard?token=${encodedData}`, "_blank", "noopener,noreferrer");
                if (newWindow) {
                    newWindow.opener = null; // सुरक्षा की एक और परत
                }
            }
        } catch (error) {
            console.error("Login Handler Error:", error);
        }
    };


    return (

        <>
            <TopHeaderBusiness />
            <MapContainer center={center} zoom={5} style={{ height: '80%', width: '99%', marginTop: ".8rem" }}>
                <TileLayer
                    url="https://api.maptiler.com/maps/basic-v2/256/{z}/{x}/{y}.png?key=wqBRkwqr9CEgeNgas9mP"
                    attribution='&copy; <a href="https://www.maptiler.com/copyright/">MapTiler</a> & <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                />


                {logData
                    .filter((data) => data.LATITUDE && data.LONGITUDE)
                    .map((location, index) => {
                        const markerIcon = location.STATUS?.toLowerCase() === 'online' ? greenIcon : redIcon;
                        return (
                            <Marker
                                key={index}
                                position={[parseFloat(location.LATITUDE), parseFloat(location.LONGITUDE)]}
                                icon={markerIcon}
                            >
                                <Tooltip direction="top" offset={[0, -20]} opacity={1}>
                                    <div className="tooltip-class">
                                        <strong><h6>
                                            <Link
                                                // href="#"
                                                to=""
                                                // target="_blank"
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    handleLoginClick(location.USER_ID, location.PASSWORD, location.USER_TYPE); // Call the function to login
                                                    window.open("/userDashboard", "_blank", "noopener,noreferrer");
                                                }}
                                                style={{ textDecoration: "none", color: "#007BFF" }}

                                            >
                                                {location.user}
                                            </Link>
                                            
                                        </h6></strong>
                                        <strong style={{ fontSize: "15px", color: "#007BFF" }}>Plant Capacity:</strong><span style={{ fontSize: "15px", color: "#007BFF" }}>{location.Plant_capacity}</span> <br />
                                        <strong>Plant Location:</strong> {location.PLANT_LOCATION}<br />
                                        <strong>Total KWH:</strong> {location.TOTAL_KWH}
                                        <strong>Current KW:</strong> {location.LKW}<br />
                                        <strong>Status:</strong>
                                        <span
                                            className='blink'
                                            style={{
                                                color:
                                                    location.STATUS?.toLowerCase() === 'online'
                                                        ? 'green'
                                                        : location.STATUS?.toLowerCase() === 'offline'
                                                            ? 'red'
                                                            : 'orange' // optional fallback
                                            }}
                                        >
                                            {location.STATUS}
                                        </span>
                                        <br />

                                        <strong>Alarm:</strong><span className='blink' style={{ color: "orange" }}>{location.ALARM}</span><br />


                                    </div>
                                </Tooltip>
                                <Popup>
                                    <strong><h6>

                                        {/* <Link
                                            // href="#"
                                            to=""
                                            // target="_blank"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                handleLoginClick(location.USER_ID, location.PASSWORD, location.USER_TYPE); // Call the function to login
                                                window.open("/userDashboard", "_blank", "noopener,noreferrer");
                                            }}
                                            style={{ textDecoration: "none", color: "#007BFF" }}

                                        >
                                            {location.user}
                                        </Link> */}

                                        <Link
                                            to="#"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                handleLoginClick(location.USER_ID, location.PASSWORD, location.USER_TYPE);
                                            }}
                                            style={{ textDecoration: "none", color: "#007BFF" }}
                                        >
                                            {location.user}
                                        </Link>
                                    </h6></strong>
                                    <strong style={{ fontSize: "15px", color: "#007BFF" }}>Plant Capacity:</strong><span style={{ fontSize: "15px", color: "#007BFF" }}>{location.Plant_capacity}</span> <br />
                                    <strong>Plant Location:</strong> {location.PLANT_LOCATION}<br />
                                    <strong>Total KWH:</strong> {location.TOTAL_KWH}<br />
                                    <strong>Current KW:</strong> {location.LKW}<br />
                                    <strong>Status:</strong>
                                    <span
                                        className='blink'
                                        style={{
                                            color:
                                                location.STATUS?.toLowerCase() === 'online'
                                                    ? 'green'
                                                    : location.STATUS?.toLowerCase() === 'offline'
                                                        ? 'red'
                                                        : 'orange' // optional fallback
                                        }}
                                    >
                                        {location.STATUS}
                                    </span>
                                    <br />

                                    <strong>Alarm:</strong><span className='blink' style={{ color: "orange" }}>{location.ALARM}</span><br />
                                </Popup>
                            </Marker>
                        );
                    })}
            </MapContainer>
        </>

    );
}